export const LOW = 50;
export const HIGH = 75;
export const ANALYST_LOW = 24;
export const ANALYST_HIGH = 76;
